<template>
  <v-dialog v-model="visible" max-width="65%">
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-star-check</v-icon>
         {{ $t ('Validar ticket para la salida') }}
      </v-card-title>

      <v-card-text class="pa-0">
        <v-stepper v-model="numeroPaso" style="background: #F0F0EE" flat>
          <v-stepper-header>
            <v-stepper-step :complete="numeroPaso > 1" step="1">
              Selección de producto a validar
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="numeroPaso > 2" step="2">
              Confirmar validación
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0">

              <v-card flat tile>
                <v-card-text class="pa-0">
                  <v-data-table
                    v-model="seleccion"
                    :headers="cabeceras"
                    :items="arrayProductos"
                    :loading="cargando"
                    item-key="clapro"
                    dense
                    single-select
                    @click:row="tablaProductosClickRow"
                    @current-items="tablaProductosCurrentItems"
                    @dblclick:row="tablaProductosDblClickRow"
                  >
                    <template v-slot:top>
                      <v-container style="background: #dcdcd0;" class="px-0">
                        <v-row dense align="center">
                          <v-col cols="auto">
                            <v-text-field
                              ref="busqueda"
                              style="width: 200px"
                              v-model="busqueda"
                              label="Nº producto o Matrícula"
                              class="ml-4"
                              hide-details
                              v-inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 12 }"
                              @keypress.enter="buscarProductos"
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-btn
                              small
                              rounded
                              color="primary"
                              class="mr-2 py-4 mt-3"
                              :loading="cargando"
                              :disabled="botonBuscarDeshabilitado"
                              @click="buscarProductos">
                              <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>

                    <template v-slot:[`item.id_ins`] = "{ item }">
                      {{ $tablasConsulta.registroPorClave ('ins', item.id_ins, 'nom') }}
                    </template>
                    <template v-slot:[`item.numpro`]="{ item }">
                      <span class="numero-producto">{{ item.numpro }}</span>
                    </template>
                    <template v-slot:[`item.mat`]="{ item }">
                      <template v-if="item.mat">
                        <span class="matricula">{{ item.mat }}</span>
                      </template>
                    </template>
                    <template v-slot:[`item.fechorent`] = "{ item }">
                      {{ formatearFechaHora (item.fechorent) }}
                    </template>
                    <template v-slot:[`item.fechorpag`] = "{ item }">
                      {{ formatearFechaHora (item.fechorpag) }}
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="green darken-2" :disabled="seleccion.length==0" @click="botonIrAPaso2" ref="botonIrAPaso2">{{ $t ('Siguiente') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

            <v-stepper-content step="2" class="pa-0">

              <v-card flat tile>
                <v-card-text>
                  <v-container fluid>
                    <v-row justify="center">
                      <v-col cols="12" md="7" lg="4">

                        <v-text-field
                          label="Aparcamiento"
                          prepend-inner-icon="mdi-file-powerpoint-box"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.aparcamiento"
                        >
                        </v-text-field>
                        <v-text-field
                          label="Grupo de productos"
                          class="mt-6"
                          prepend-inner-icon="mdi-package-variant"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.descripcion_grupo_productos"
                        ></v-text-field>

                        <v-text-field
                          label="Numero producto"
                          class="mt-6"
                          prepend-inner-icon="mdi-ticket-outline mdi-rotate-90"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.numero_producto"
                        ></v-text-field>

                        <v-text-field
                          label="Matrícula"
                          class="mt-6"
                          prepend-inner-icon="mdi-car"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.matricula"
                        ></v-text-field>

                        <v-text-field
                          label="Fecha/hora de entrada"
                          class="mt-6"
                          prepend-inner-icon="mdi-arrow-right-bold"
                          dense
                          hide-details
                          readonly
                          :value="formatearFechaHora (datosCobro.fecha_hora_entrada)"
                        ></v-text-field>

                        <v-text-field
                          label="Duración de la estancia"
                          class="mt-6"
                          prepend-inner-icon="mdi-clock-time-four-outline"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.literal_duracion_estancia"
                        ></v-text-field>

                        <v-text-field
                          label="Tarifa aplicada"
                          class="mt-6"
                          prepend-inner-icon="mdi-clipboard-text-clock-outline"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.descripcion_tarifa_aplicada"
                        ></v-text-field>

                        <v-text-field
                          class="mt-6"
                          style="margin-left: 50%"
                          label="Importe total"
                          prepend-inner-icon="mdi-cash"
                          :suffix="$utilI18N.simboloMoneda"
                          dense
                          hide-details
                          readonly
                          :value="datosCobro.importe_total"
                        ></v-text-field>

                        <v-textarea
                          ref="observaciones"
                          class="mt-6"
                          label="Observaciones"
                          prepend-inner-icon="mdi-pencil"
                          dense
                          rows="2"
                          auto-grow
                          hide-details
                          v-model="observaciones"
                        ></v-textarea>

                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-btn text color="#90908E" @click="botonIrAPaso1">{{ $t ('Atrás') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text color="green darken-2" @click="botonValidarTicket" ref="botonValidarTicket">{{ $t ('Validar ticket') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { DateTime } from "luxon";
import api from "@/api";

export default {
  components: {  },
  data () {
    return {
      cabeceras: [
        { text: this.$t ("Aparcamiento"), value: "id_ins" },
        { text: this.$t ("Núm. producto"), value: "numpro" },
        { text: this.$t ("Grupo productos"), value: "desgrupro" },
        { text: this.$t ("Matrícula"), value: "mat" },
        { text: this.$t ("Fecha/Hora entrada"), value: "fechorent" },
        { text: this.$t ("Fecha/Hora pago"), value: "fechorpag" },
        { text: this.$t ("Aparato último movimiento"), value: "desapaultmov" },
      ],

      sagabroker: null,
      tablaValidacionesTickets: null,

      visible: false,
      cargando: false,
      numeroPaso: 1,
      arrayInstalaciones: [],
      arrayProductos: [],
      gruposProductosDisponibles: [],
      busqueda: '',
      ultimaBusqueda: '',
      seleccion: [],
      datosCobro: {},
      tokenCobro: '',
      observaciones: '',
    }
  },
  computed: {
    botonBuscarDeshabilitado () {
      return this.busqueda.length < 3 || this.cargando;
    }
  },
  methods: {
    abrirVentana (sagabroker, tablaValidacionesTickets) {
      this.sagabroker = sagabroker;
      this.tablaValidacionesTickets = tablaValidacionesTickets;

      this.numeroPaso = 1;
      this.arrayProductos = [];
      this.busqueda = '';
      this.ultimaBusqueda = '';
      this.seleccion = [];

      this.visible = true;

      api.obtenerInstalacionesOperador ()
        .then (respuesta => this.arrayInstalaciones = respuesta.data.instalaciones);

      // establecemos el foco en el campo de busqueda
      setTimeout (() => {
        this.$refs['busqueda'].focus();
      }, 250);
    },
    buscarProductos () {
      if (this.botonBuscarDeshabilitado)
        return;

      this.arrayProductos = [];
      this.cargando = true;

      let arrayPromesasBusqueda = [];
      this.arrayInstalaciones.forEach ((instalacion) => {
        arrayPromesasBusqueda.push (
          this.sagabroker.solicitarProductosPorNumeroOMatricula (instalacion.id_ins, this.busqueda, '2022-01-01T00:00:00')
            .then ((respuesta) => {
              respuesta.contenido.productos.forEach (fila => fila.id_ins = instalacion.id_ins);
              return respuesta;
            })
        );
      });

      Promise.allSettled (arrayPromesasBusqueda)
        .then ((resultados) => {
          resultados.forEach ((resultado_promesa) => {
            if (resultado_promesa.status == "fulfilled") {
              this.arrayProductos = this.arrayProductos.concat (resultado_promesa.value.contenido.productos);
            }
          })
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    formatearFechaHora (fechaHoraISO) {
      if (fechaHoraISO != null)
        return DateTime.fromISO (fechaHoraISO).toFormat('dd-MM-yyyy HH:mm');
      else
        return "-";
    },
    tablaProductosClickRow (fila) {
      this.seleccion = [fila];
    },
    tablaProductosCurrentItems (filas) {
      if (filas.length == 1) {
        this.seleccion = filas;
        this.$nextTick (() => {
          this.$refs['botonIrAPaso2'].$el.focus();
        });
      } else
        this.seleccion = [];
    },
    tablaProductosDblClickRow () {
      this.botonIrAPaso2();
    },
    botonIrAPaso1 () {
      this.numeroPaso = 1;
    },
    botonIrAPaso2 () {
      api.pagarEstanciaProductoPaso1 ({ id_instalacion: this.seleccion[0].id_ins,
                                           clave_producto: this.seleccion[0].clapro })
        .then ((respuesta) => {
          if (respuesta.data.error) {
            this.$cuadroDeDialogo.mostrar ('Error!', respuesta.data.error, ['Aceptar']);
            return;
          }

          this.datosCobro = respuesta.data.datos_cobro;
          this.tokenCobro = respuesta.data.token_cobro;

          this.numeroPaso = 2;
          this.$nextTick (() => {
            this.$refs['observaciones'].focus();
          });
        })
    },
    botonValidarTicket () {
      api.pagarEstanciaProductoPaso2 ({ id_instalacion: this.seleccion[0].id_ins,
                                           token_cobro: this.tokenCobro,
                                           observaciones: this.observaciones })
        .then ((respuesta) => {
          if (respuesta.data.error) {
            this.$cuadroDeDialogo.mostrar ('Error!', respuesta.data.error, ['Aceptar']);
            return;
          }

          this.$cuadroDeDialogo.mostrarEx ({
            propsDialog: { width: "450px", maxWidth: "80%" },
            propsCard: { dark: false },
            titulo: {
              texto: 'Recibo de pago',
              estilo: "background: #C5E1A5",
              icono: {
                nombre: "mdi-receipt-text-check",
                large: true
              }
            },
            cuerpo: {
              props: { class: 'caja-recibo', style: 'font-family: monospace; font-size: 13px; white-space: pre; line-height: 12pt; text-align: center; background-color: #FFFFF0; padding: 8px;' },
              mensajes: respuesta.data.recibo_cobro
            },
            acciones: {
              botones: [
                { identificador: 'ACEPTAR', texto: this.$t ('Aceptar'), props: { text: true, color: "primary" } }
              ]
            }
          });
          this.tablaValidacionesTickets.actualizarDatos();
          this.visible = false;
        });
    },
    botonCancelarClick () {
      this.visible = false;
    }
  }
}
</script>

<style>
.numero-producto {
  font-family: monospace;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: -0.3px;
}
.matricula {
  font-family: monospace;
  font-weight: 600;
  padding: 1px 4px 1px 4px;
  border: 1px #A0A0A0 solid;
  border-radius: 5px;
  background: #F4F4F4
}
</style>